import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Typography, Tooltip, Fab } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import Layout from '@components/Layout';
import CustomerTable from '@components/customer/CustomerTable';

function CustomerListPage() {
    const { t } = useTranslation();
    return (
        <Layout withFloatingButton={true}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Typography>{t('Customer management')}</Typography>
            </Breadcrumbs>
            <CustomerTable />
            <RouterLink to="/customers/create">
                <Tooltip title={t('Create customer')} placement="top" arrow>
                    <Fab color="primary" aria-label={t('Create customer')}
                        className="main-fab" sx={{ boxShadow: 6 }}>
                        <AddIcon />
                    </Fab>
                </Tooltip>
            </RouterLink>
        </Layout>
    );
}

export default CustomerListPage;
